import React, { Component, useRef, useState } from "react"
import Select, { components } from "react-select"
import Animated from "react-select/animated"
import ReactDOM from "react-dom"

let styles = {
   container: provided => ({
      display: "inline-block",
      position: "relative",
      width: "100%",
      height: "100%",
      background: "#FFFFFF",
      border: "1px solid #CED4DA",
      borderRadius: "4px",
      width: "130px",
      fontSize: "13px",
      ...provided,
   }),
   control: (provided, state) => ({
      ...provided,
      minHeight: "45px",
      borderColor: "#9d9d9d",
      border: state.isFocused ? 0 : 0,
      boxShadow: state.isFocused ? 0 : 0,
      "&:hover": {
         borderColor: "#9d9d9d",
      },
   }),
   dropdownIndicator: provided => ({
      ...provided,
      display: "none",
   }),
   multiValue: (provided, state) => ({
      ...provided,
      display: "flex",
   }),
   multiValueLabel: (provided, state) => ({
      ...provided,
      display: "block",
   }),
   multiValueRemove: (provided, state) => ({
      ...provided,
      display: "block",
   }),
}
const MAX_VISIBLE_OPTIONS = 1

class AutoComplete extends Component {
   constructor(props) {
      super(props)
      this.state = {
         showMoreDropdown: false,
      }
   }

   formatOptionLabel = (option, { context }) => {
      return (
         <div>
            <div className="auto-complete-label">{option.label}</div>
            {option.description && (
               <div className="description">{option.description}</div>
            )}
         </div>
      )
   }

   CustomMultiValue = props => {
      const { data, index } = props
      if (
         !Array.isArray(this.props.value) ||
         this.props.value.length === 0 ||
         !this.props.value.some(v => v.value === data.value)
      ) {
         return null
      }
      const [showDropdown, setShowDropdown] = useState(false)
      const [dropdownPos, setDropdownPos] = useState({
         left: 0,
         bottom: 0,
         width: 0,
      })
      const moreRef = useRef()
      const timeoutRef = useRef()

      if (
         this.props.isMulti &&
         Array.isArray(this.props.value) &&
         this.props.value.length > MAX_VISIBLE_OPTIONS &&
         index === MAX_VISIBLE_OPTIONS
      ) {
         const remainingCount = this.props.value.length - MAX_VISIBLE_OPTIONS
         const handleMouseEnter = () => {
            if (timeoutRef.current) clearTimeout(timeoutRef.current)
            if (moreRef.current) {
               const rect = moreRef.current.getBoundingClientRect()
               setDropdownPos({
                  left: rect.left,
                  bottom: window.innerHeight - rect.top + 4,
                  width: rect.width,
               })
            }
            setShowDropdown(true)
         }
         const handleMouseLeave = () => {
            timeoutRef.current = setTimeout(() => {
               setShowDropdown(false)
            }, 250)
         }
         const handleDropdownEnter = () => {
            if (timeoutRef.current) clearTimeout(timeoutRef.current)
            setShowDropdown(true)
         }
         const handleDropdownLeave = () => {
            timeoutRef.current = setTimeout(() => {
               setShowDropdown(false)
            }, 250)
         }
         return (
            <>
               <div
                  ref={moreRef}
                  className={`more-indicator ${props.className}`}
                  onMouseEnter={handleMouseEnter}
                  onMouseLeave={handleMouseLeave}
               >
                  +{remainingCount}
               </div>
               {showDropdown &&
                  ReactDOM.createPortal(
                     <div
                        className="more-items-dropdown"
                        style={{
                           left: dropdownPos.left,
                           bottom: dropdownPos.bottom,
                           minWidth: dropdownPos.width,
                        }}
                        onMouseEnter={handleDropdownEnter}
                        onMouseLeave={handleDropdownLeave}
                     >
                        <div style={{ height: "8px", marginTop: "-8px" }} />
                        <div className="more-items-dropdown-content">
                           {this.props.value
                              .slice(MAX_VISIBLE_OPTIONS)
                              .map((item, idx) => (
                                 <div key={idx} className="more-item">
                                    {item.label}
                                 </div>
                              ))}
                        </div>
                     </div>,
                     document.body
                  )}
            </>
         )
      }
      if (
         this.props.isMulti &&
         Array.isArray(this.props.value) &&
         this.props.value.length > MAX_VISIBLE_OPTIONS &&
         index > MAX_VISIBLE_OPTIONS
      ) {
         return null
      }
      return <components.MultiValue {...props} />
   }

   render() {
      let {
         className = "",
         classNamePrefix = "",
         options,
         onInputChange = () => {},
         onChange,
         handleBlur = () => {},
         customStyles = undefined,
         maxMenuHeight,
         isClearable = false,
         placeholder = "",
         isLoading = false,
         value,
         isMulti = false,
         handleScroll = undefined,
         handleOnFocus = undefined,
         selectRef,
         isOptionDisabled = undefined,
         isDisabled,
         closeMenuOnSelect = true,
         hideDropdownArrow = false,
         onKeyDown = () => {},
         ...rest
      } = this.props

      let currentStyles = customStyles ? { ...customStyles } : { ...styles }

      if (!hideDropdownArrow) {
         currentStyles.dropdownIndicator = provided => ({
            ...provided,
         })
      } else {
         currentStyles.dropdownIndicator = provided => ({
            ...provided,
            display: "none",
         })
      }

      const customComponents = isMulti
         ? {
              //   ...Animated(),
              MultiValue: this.CustomMultiValue,
              Placeholder: props => {
                 return <components.Placeholder {...props} />
              },
           }
         : Animated()

      return (
         <div style={{ position: "relative" }}>
            <Select
               isDisabled={isDisabled}
               onFocus={handleOnFocus}
               onBlur={handleBlur}
               ref={selectRef}
               onMenuScrollToBottom={handleScroll}
               className={className}
               classNamePrefix={classNamePrefix}
               options={options}
               onInputChange={onInputChange}
               formatOptionLabel={this.formatOptionLabel}
               onChange={onChange}
               styles={currentStyles}
               maxMenuHeight={maxMenuHeight}
               isClearable={isClearable}
               placeholder={placeholder}
               closeMenuOnSelect={closeMenuOnSelect}
               isLoading={isLoading}
               value={Array.isArray(value) && !value.length ? null : value}
               isOptionDisabled={isOptionDisabled}
               isMulti={isMulti}
               hideSelectedOptions={false}
               components={customComponents}
               onKeyDown={onKeyDown}
               {...rest}
            />
         </div>
      )
   }
}

export default AutoComplete
